import { reduxKey, } from './constants';
export var FolderType;
(function (FolderType) {
    FolderType["Collection"] = "collection";
    FolderType["Gallery"] = "gallery";
})(FolderType || (FolderType = {}));
//# sourceMappingURL=types.js.map